import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

import FontAwesomeIcon from "./font-awesome-icon";

Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  render: h => h(App),
}).$mount('#app')

document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('.navbar-toggler');
  const target = document.querySelector('.navbar-collapse');

  if (trigger && target) {
    trigger.addEventListener('click', function() {
      target.classList.toggle('show');
    });
  }
});
